
import Div from "@jumbo/shared/Div";
import { Button, Card, Grid, Paper, Typography } from "@mui/material";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { postSaveObjectApi, putUpdateObjectApi } from "api/general";
import { isTherePeriodicReportApi, isThereSameMeetingNoApi } from 'api/meeting';
import MeetingInfoTab from 'app/components/Tabs/MeetingInfoTab';
import { swal_error } from 'app/utils/appHelpers';
import { MEETINGS } from "app/utils/constants/customConstant";
import { addMeetingToReduxList, getMeetingListFromStateByPageType, updateMeetingListAction } from "app/utils/meetingReduxHelpers";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAllMMList, setCurrentMeeting } from "stores/meeting";
import MeetingAgendaTab from "../Tabs/MeetingAgendaTab";
import MeetingUserTab from "../Tabs/MeetingUserTab";
import { periodicReportCutoffDate } from "config";
import Swal from "sweetalert2";



function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Div sx={{ p: 1, ml: 1, mr: 1 }}>
                    <Typography>{children}</Typography>
                </Div>
            )}
        </div>
    );
}

const MeetingCard = ({ value, setValue, afterUpdateFunc, addAfterTable, setTabsLength,
    saveButtonStatus, addMeetingDialogStatus, onClose, setSaveButtonStatus, type
}) => {

    const dispatch = useDispatch();
    const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
    const authUser = useSelector(state => state.auth.authUser);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const unitList = useSelector((state) => state.unit.data || []);

    const [meetingError, setMeetingError] = useState({ unitId: 0, meetingNo: 0, pdate: '' });
    const pageType = useSelector((state) => state.meeting.pageType);
    const [currentMeetingList, setCurrentMeetingList] = useState([]);
    const meetingStore = useSelector((state) => state.meeting);

    useEffect(() => {

        setCurrentMeetingList(getMeetingListFromStateByPageType({ meetingStore }));
    }, [meetingStore.allMeetingList, meetingStore.pageType]);


    const handleDataChange = (data) => {
        dispatch(setCurrentMeeting(data));
    };

    useEffect(() => {
        const getAPI = async () => {

            if (saveButtonStatus !== undefined && saveButtonStatus) {
                await handleAddUpdateMeetingInfo();
                setSaveButtonStatus(false);
            }
        }
        getAPI()
    }, [saveButtonStatus]);


    useEffect(() => {
        if (currentMeeting.id === undefined) {
            setValue(0);
        }
    }, [currentMeeting.id, setValue]);


    const validate = () => {
        let isValid = true;
        const newErrors = {};

        if (!currentMeeting.unitId) {
            newErrors.unitId = "Kurul/Kol/Komisyon bilgisi zorunludur";
            isValid = false;
        }
        if (!currentMeeting.meetingNo) {
            newErrors.meetingNo = "Toplantı numarası zorunludur";
            isValid = false;
        }
        if (!currentMeeting.pdate) {
            newErrors.pdate = "Tarih bilgisi zorunludur";
            isValid = false;
        }

        setMeetingError(newErrors);
        return isValid;
    }

    const handleNextTab = () => {
        if (value < tabs.length - 1) {
            setValue(value + 1);
        }
    };

    const handlePreviousTab = () => {
        if (value > 0) {
            setValue(value - 1);
        }
    };


    const handleAddUpdateMeetingInfo = async () => {


        const validateResult = validate();
        if (!validateResult) {
            // Validasyon başarısız, işlem iptal edildi.
            return;
        }

        const currentUnit = unitList.find(unit => unit.id === currentMeeting.unitId);

        if (currentUnit.uploadFileStatus === 1) {
            //   dosya yükleme zorunluluğu var
            const currentDate = new Date();
            if (currentDate < periodicReportCutoffDate) { // ilk defa uygulanacagindan onceki donemlerdeki raporu aramaması icin eklendi


            } else {
                const result = await isTherePeriodicReportApi(currentMeeting.unitId);
                let data = result.data;

                if (data && data.length > 0 && data[0].count === 0) { // count varsa rapor vardır 

                    if (type === "dialog") {
                        onClose();
                    }

                    swal_error("Bu kurul/kol/komisyon için dönemsel rapor olmadığından yeni toplantı oluşturulamaz.", 5000);
                    return;
                }
            }



        }



        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: {
                container: 'swal-container-custom'
            },
            didOpen: () => Swal.showLoading()
        });


        if (currentMeeting.id !== undefined) { // guncelleme

            const { user, users, decisionCount, isThereReminder, ...meetingObj } = currentMeeting;
            meetingObj.adminUserId = authUser.id;
            const result = await putUpdateObjectApi(MEETINGS, meetingObj);
            if (result.status) {
                dispatch(setCurrentMeeting({ ...meetingObj }));

                if (value === 0) {
                    handleNextTab();
                }

                const updatedMeeting = {
                    ...meetingObj,
                    user: authUser,
                    users,
                    decisionCount,
                    isThereReminder
                };
                if (type === "dialog") {
                    setSaveButtonStatus(false)
                }

                dispatch(setCurrentMeeting(updatedMeeting))

                afterUpdateFunc && afterUpdateFunc(
                    updatedMeeting
                );


            }

            Swal.close();

        } else { // kaydetme
            if (currentMeeting.meetingNo !== undefined) {
                const result = await isThereSameMeetingNoApi(currentMeeting.unitId, currentMeeting.meetingNo);
                let data = result.data;
                if (data && data.length > 0 && data[0].count !== 0) { // count varsa aynı meetingno var 
                    if (type === "dialog") {
                        onClose();
                    }

                    swal_error(`${currentMeeting.unit} için aynı toplantı numarası var veya bu toplantı numarasına ait toplantı silinmiştir. Farklı bir toplantı numarası seçiniz.`, 5000);
                    return;
                }
            }

            const { decisionCount, ...updatedMeeting } = currentMeeting;
            const result = await postSaveObjectApi(MEETINGS, updatedMeeting);

            if (result.status) {
                Swal.close();

                const { userRoles, ...user } = authUser;
                const meetingData = {
                    id: result.data.insertId,
                    ...currentMeeting,
                    user,
                    users: []
                };
                dispatch(setCurrentMeeting(meetingData));
                if (type === "dialog") {
                    addAfterTable(meetingData);
                    setSaveButtonStatus(false)
                } else {

                    if (addAfterTable) {
                        addAfterTable(meetingData);
                    } else {
                        if (currentMeetingList.length > 0) {
                            const newList = addMeetingToReduxList(currentMeetingList, meetingData);
                            dispatch(updateMeetingListAction(newList)); // bAK !!!!
                            dispatch(setAllMMList(newList));
                        }

                    }
                }




                if (value === 1) {
                    setIsButtonDisabled(true);
                }

                if (value < tabs.length - 1) {
                    setValue(value + 1);
                }

            }
        }



    };

    const tabs = [
        { id: 1, name: "BİLGİLER", component: <MeetingInfoTab handleDataChange={handleDataChange} errors={meetingError} /> },
        { id: 2, name: "ÜYELER", component: <MeetingUserTab componentType={"user"} /> },
        { id: 3, name: "KATILIMCILAR", component: <MeetingUserTab componentType={"participant"} /> },
        { id: 4, name: "GÜNDEMLER", component: <MeetingAgendaTab /> }
    ]


    useEffect(() => {
        setTabsLength(tabs.length);

    }, [tabs.length, setTabsLength]);


    return (
        <Paper>

            <React.Fragment>
                <Card wrapperSx={{ backgroundColor: 'background.paper', pt: 0 }}>
                    <Div sx={{ width: '100%' }}>
                        <Div sx={{ borderBottom: 1, display: 'flex', alignItems: 'center', borderColor: 'divider' }}>

                            {value !== 3 && (
                                <Tabs
                                    value={value}
                                    onChange={(event, newValue) => {
                                        if (currentMeeting.id !== undefined) {
                                            setValue(newValue);
                                        }
                                    }}
                                    disabled={currentMeeting.id === undefined && value === 0}
                                >
                                    {tabs.map((tab) => (
                                        <Tab key={tab.id} label={tab.name} />
                                    ))}
                                </Tabs>
                            )}




                        </Div>

                        {tabs.map((tab, index) => (
                            <TabPanel key={tab.id} value={value} index={index}
                                sx={{ p: 0, m: 0, width: '100%' }}
                            >
                                {React.cloneElement(tab.component, { handleDataChange })}
                            </TabPanel>
                        ))}

                    </Div>
                    <Grid container spacing={1}>
                        <Grid item xs={12} style={{ margin: 10, gap: '5px', display: 'flex', justifyContent: 'flex-end' }}>
                            {
                                addMeetingDialogStatus !== true ? (
                                    <>
                                        <Button
                                            variant="outlined"
                                            onClick={handlePreviousTab}
                                            disabled={value === 0}
                                        >
                                            GERİ
                                        </Button>

                                        <Button
                                            variant="outlined"
                                            onClick={handleNextTab}
                                            disabled={(currentMeeting.id === undefined && value === 0) || value === tabs.length - 1}
                                        >
                                            İLERİ
                                        </Button>

                                        {value === 0 ? (
                                            <Button
                                                id="saveButton"
                                                disabled={isButtonDisabled}
                                                variant="contained"
                                                onClick={() =>
                                                    handleAddUpdateMeetingInfo()
                                                }
                                            >
                                                {currentMeeting.id !== undefined ? "Güncelle" : "Kaydet"}
                                            </Button>
                                        ) : null}
                                    </>
                                ) : null
                            }
                        </Grid>
                    </Grid>


                </Card>


            </React.Fragment>



        </Paper >
    );
};


const style = document.createElement('style');
style.innerHTML = `
                    .swal - container - custom {
                        z- index: 10000!important;
            }
            `;
document.head.appendChild(style);

export default MeetingCard;